import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('dcelc_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('dcelc_session_id', sessionId);
  }
  return sessionId;
};

const useAnalytics = () => {
  const location = useLocation();
  const lastTrackedPath = useRef('');

  useEffect(() => {
    // Avoid tracking the same page twice in a row
    if (lastTrackedPath.current === location.pathname) return;
    lastTrackedPath.current = location.pathname;

    const trackPageVisit = async () => {
      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        
        await fetch(`${API_URL}/api/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page_path: location.pathname,
            page_title: document.title,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            screen_width: window.screen.width,
            screen_height: window.screen.height,
            session_id: getSessionId(),
          }),
        });
      } catch (error) {
        // Silently fail - don't interrupt user experience for analytics
        console.debug('Analytics tracking error:', error);
      }
    };

    // Small delay to ensure page has loaded
    const timer = setTimeout(trackPageVisit, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default useAnalytics;
